import { useQuery, useMutation, useQueryClient } from "react-query";
import {
	getInventoryTakingSessions,
	getInventoryTakingLookups,
	getInventoryTakingResults,
	finalizeInventoryTaking,
	exportInventoryTaking,
} from "@/api/InventoryTaking/inventory-taking-api";

export const inventoryTakingKey = "inventory-taking";

export function useInventoryTakingSessions(filters, options = {}) {
	return useQuery([inventoryTakingKey, "sessions", filters], () => getInventoryTakingSessions(filters), {
		...options,
	});
}

export function useInventoryTakingLookups(options = {}) {
	return useQuery([inventoryTakingKey, "lookups"], () => getInventoryTakingLookups(), {
		staleTime: 5 * 60 * 1000,
		...options,
	});
}

export function useInventoryTakingResults(sessionId, options = {}) {
	return useQuery([inventoryTakingKey, "results", sessionId], () => getInventoryTakingResults(sessionId), {
		enabled: Boolean(sessionId),
		...options,
	});
}

export function useFinalizeInventoryTaking() {
	const queryClient = useQueryClient();

	return useMutation((sessionId) => finalizeInventoryTaking(sessionId), {
		onSuccess: () => {
			queryClient.invalidateQueries([inventoryTakingKey]);
		},
	});
}

export function useExportInventoryTaking() {
	return useMutation((sessionId) => exportInventoryTaking(sessionId));
}
